import React, { Component } from 'react'

import twaddleIcon from "../images/twaddle_icon.png"
import bala from "../images/bala.jpeg"
import sid from "../images/sid.jpeg"
import pranoppal from "../images/pranoppal.jpeg"


const Team = () => (    
    <div className="team" id="navigateTeam">
        <div id="navbar">
            <div id="titleIconContainer2"><img id="titleIcon2" src={ twaddleIcon } /></div>
            <span id="title2">twaddle</span>
            <div id="tabList2Container">    
                <ul id="tabList2">
                    <li><a href="#navigateTeam">team</a></li>
                    <li><a href="#">about</a></li>
                    <li><a href="#">products</a></li>
                </ul>
            </div>
            
        </div>
        <center><span id="teamTitle">team</span></center>
        <center><div id="teamListImages">
            <img class="displayPicture" src={ bala } />
            <img class="displayPicture" src={ sid } />
            <img class="displayPicture" src={ pranoppal } />
            <span class="name">Sayooj Balakrishnan<br/><span class="position">co-founder</span></span>
            <span class="name">Siddharth Kulkarni<br/><span class="position">co-founder</span></span>
            <span class="name">Pranoppal Kalita<br/><span class="position">co-founder</span></span>
            {/* <center>
                <table>
                    <tr>
                        <td><img id="bala" src={ bala } /></td> 
                        <td><img id="sid" src={ sid } /></td>
                        <td><img id="pranoppal" src={ pranoppal } /></td>
                    </tr>
                    <tr>
                        <td>Sayooj Balakrishnan</td>
                        <td>Siddharth Kulkarni</td>
                        <td>Pranoppal</td>
                    </tr>
                </table>
            </center> */}
        </div></center>
    </div>
)


export default Team